export default __webpack_public_path__ + "static/staff-photo-default-4b7fce4a1dabe26abaf8c3dbd4b221f8.jpg";